import React, { useEffect } from 'react';
import { makeStyles, Paper, SwipeableDrawer } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import './MobileSIdeBar.scss';
import 'pages/Home/Home.scss';
import { CircularProgressBar } from 'components/common/ProgressBar/CircularProgressBar';
import { useViewport } from 'utils/getViewport/getViewport';
import { AssessmentNavBarIcons } from 'components/threepp/assessment/NavBar/AssessmentNavBarIcons/AssessmentNavBarIcons';
import { EventEmitterTypes, SidebarViews } from 'utils/constants';
import { EventEmitter } from 'utils/events';
import { SidebarWrapper } from '../SidebarWrapper';

const useStyles = makeStyles(() => ({
  drawerPaper: {
    backgroundColor: '#F7F7F7'
  },
  drawerContainer: {
    overflow: 'auto'
  },
  assessmentNavbar: {
    position: 'sticky',
    top: '0'
  }
}));

export const MobileSideBar = props => {
  const {
    isHomePage,
    assessment,
    assessmentLanguages,
    assessmentProgress,
    percentComplete,
    totalAnsweredQuestion,
    totalOpenQuestion,
    openAssessments,
    isAssessmentPage,
    currentUser,
    assessmentAnsweredQuestions,
    assessmentTotalQuestions,
    participantsData,
    isAssessmentDisabled,
    isOwner,
    onDeleteUser,
    onUpdateUser,
    filterVariables,
    setTriggerGuidedTour,
    actions,
    selectedCategory,
    visibleCategory,
    activeUsers,
    currentCategory,
    hasComments
  } = props;
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
    width: '80%'
  });
  const classes = useStyles();
  const { t } = useTranslation();
  const { isMobile } = useViewport();
  const [sidebarView, setSidebarView] = React.useState(SidebarViews.SECTIONS);
  const toggleDrawer = (right, open) => event => {
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setState({ ...state, [right]: open });
  };
  const sidebarViewChangeHandler = view => setSidebarView(view);

  useEffect(() => {
    EventEmitter.subscribe(EventEmitterTypes.TOGGLE_MOBILE_SIDEBAR, ({ open }) => setState(prevState => ({ ...prevState, right: open })));
    return () => EventEmitter.unsubscribe(EventEmitterTypes.TOGGLE_MOBILE_SIDEBAR);
  }, []);

  useEffect(() => {
    if (!isMobile) {
      setState(prevState => ({ ...prevState, right: false }));
    }
  }, [isMobile]);

  return (
    <React.Fragment>
      <SwipeableDrawer
        classes={{ paper: classes.drawerPaper }}
        anchor="right"
        open={state.right}
        onClose={toggleDrawer('right', false)}
        onOpen={toggleDrawer('right', true)}
      >
        {isHomePage && (
          <div className={isMobile ? 'mobile-sidebar-paper' : 'col-sm-3'}>
            <div className="text-center">
              <Paper className="paper-cards" elevation={3}>
                <p className="paper-title">{t('home.percentComplete')}</p>
                <CircularProgressBar assessmentProgress={percentComplete} />
                <p className="paper-progress-text">{`${totalAnsweredQuestion}/${totalOpenQuestion} ${t('common.complete')}`}</p>
              </Paper>
            </div>
            <div className="text-center">
              <Paper className="paper-cards" elevation={3}>
                <p className="paper-title">{t('home.openAssessments')}</p>
                <p className="paper-text"> {openAssessments}</p>
              </Paper>
            </div>
            <div className="text-center">
              <Paper className="paper-cards" elevation={3}>
                <p className="paper-title">{t('home.openQuestions')}</p>
                <p className="paper-text"> {totalOpenQuestion}</p>
              </Paper>
            </div>
          </div>
        )}
        {isAssessmentPage && (
          <section className="mobile-assessment-sidebar">
            <div className={classes.assessmentNavbar}>
              <AssessmentNavBarIcons
                onIconClick={sidebarViewChangeHandler}
                sidebarView={sidebarView}
                filterVariables={filterVariables}
                activeUsers={activeUsers}
              />
            </div>
            <SidebarWrapper
              assessment={assessment}
              assessmentLanguages={assessmentLanguages}
              assessmentHelpText={assessment.helpText}
              assessmentProgress={assessmentProgress}
              assessmentAnsweredQuestions={assessmentAnsweredQuestions}
              assessmentTotalQuestions={assessmentTotalQuestions}
              participantsData={participantsData}
              sidebarView={sidebarView}
              currentUser={currentUser}
              onIconClick={sidebarViewChangeHandler}
              isAssessmentDisabled={isAssessmentDisabled}
              isOwner={isOwner}
              onDeleteUser={onDeleteUser}
              onUpdateUser={onUpdateUser}
              open={state.right}
              toggleDrawer={toggleDrawer}
              setTriggerGuidedTour={setTriggerGuidedTour}
              actions={actions}
              selectedCategory={selectedCategory}
              visibleCategory={visibleCategory}
              activeUsers={activeUsers}
              currentCategory={currentCategory}
              hasComments={hasComments}
            />
          </section>
        )}
      </SwipeableDrawer>
    </React.Fragment>
  );
};
